module.exports = __webpack_public_path__ + "static/media/t2.8bb71ca4.png";